module.exports = "/packs/media/images/icons/dollarmagnify-3d0aab01970913dd3b19a5975d62e761.png";